export default __webpack_public_path__ + "static/media/FN404.aad57624.png";